module.exports = __webpack_public_path__ + "static/media/permission.2725c90b.svg";